// extracted by mini-css-extract-plugin
module.exports = {"appLoader":"Loader_appLoader__1xx_Q","spinner":"Loader_spinner__M627_","logoSpinner":"Loader_logoSpinner__19UQa","loaderText":"Loader_loaderText__3Zf_W"};